import React from "react";

// Excerpts of the content search hits of one application (see useContentSearch).
const ContentSearchMatches = ({ hit }) => {
  if (!hit?.matches?.length) return null;
  const hidden = hit.match_count - hit.matches.length;
  return (
    <div className="border rounded-3 p-3 bg-body-tertiary">
      <div className="text-uppercase text-medium-emphasis small mb-2">
        Ocorrências na pesquisa ({hit.match_count})
      </div>
      <div className="d-flex flex-column gap-2 small">
        {hit.matches.map((match, index) => (
          <div key={index}>
            {match.truncated_start ? "… " : ""}
            {match.before}
            <mark className="px-0">{match.match}</mark>
            {match.after}
            {match.truncated_end ? " …" : ""}
          </div>
        ))}
        {hidden > 0 && (
          <div className="text-medium-emphasis">
            + {hidden} {hidden === 1 ? "ocorrência" : "ocorrências"}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentSearchMatches;
